import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _createSuper from "@babel/runtime/helpers/esm/createSuper";
import React, { Component } from 'react';
import { SVGIcon } from '@instructure/ui-svg-images';

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M981.138824,416 C1023.33929,666.991059 1241.06541,858.352941 1504,858.352941 L1504,858.352941 L1504,1566.11765 L737.313882,1566.11765 L265.411765,1920 L265.411765,1566.11765 L2.60902411e-15,1566.11765 L0,416 Z M1794.88188,0 L1920,125.097599 L1415.01477,630 L1087,302.039039 L1212.11812,176.941441 L1415.01477,379.804803 L1794.88188,0 Z",
  fillRule: "evenodd",
  stroke: "none",
  strokeWidth: "1"
});

var IconCommentsOnSolid = /*#__PURE__*/function (_Component) {
  _inherits(IconCommentsOnSolid, _Component);

  var _super = _createSuper(IconCommentsOnSolid);

  function IconCommentsOnSolid() {
    _classCallCheck(this, IconCommentsOnSolid);

    return _super.apply(this, arguments);
  }

  _createClass(IconCommentsOnSolid, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement(SVGIcon, Object.assign({}, this.props, {
        name: "IconCommentsOn",
        viewBox: "0 0 1920 1920"
      }), _ref);
    }
  }]);

  IconCommentsOnSolid.displayName = "IconCommentsOnSolid";
  return IconCommentsOnSolid;
}(Component);

IconCommentsOnSolid.glyphName = 'comments-on';
IconCommentsOnSolid.variant = 'Solid';
IconCommentsOnSolid.propTypes = _objectSpread({}, SVGIcon.propTypes);
export default IconCommentsOnSolid;
export { IconCommentsOnSolid };